import {lazy} from 'react';

const FormsIndex = lazy(() => import(/* webpackChunkName: "FormsIndex" */ './forms'));

const SimpleFormIndex = lazy(() => import(/* webpackChunkName: "SimpleFormIndex" */ './forms/simple/SimpleForm'));

const WizardIndex = lazy(() => import(/* webpackChunkName: "WizardIndex" */ './forms/steps/Wizard'));

const UploaderIndex = lazy(() => import(/* webpackChunkName: "UploaderIndex" */ './forms/uploader/simple/Uploader'));

const AccordionIndex = lazy(() => import(/* webpackChunkName: "WizardIndex" */ './forms/accordion/AccordionForms'));

const TableIndex = lazy(() => import(/* webpackChunkName: "TableIndex" */ './table'));

const EditCustomerIndex = lazy(() => import(/* webpackChunkName: "EditCustomerIndex" */ './customers'));

const EditProductIndex = lazy(() => import(/* webpackChunkName: "EditProductIndex" */ './products'));

const IconListIndex = lazy(() => import(/* webpackChunkName: "IconListIndex" */ './icons'));

const DatatableIndex = lazy(() => import(/* webpackChunkName: "DatatableIndex" */ '@/features/poc/datatables'));

export default [
	{
		name: 'poc.forms',
		path: '/poc/forms',
		exact: false,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: FormsIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.table',
		path: '/poc/table',
		exact: false,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: TableIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.simple.form',
		path: '/poc/simple/form',
		exact: false,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: SimpleFormIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.wizard.form',
		path: '/poc/wizard',
		exact: false,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: WizardIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.simple.uploader',
		path: '/poc/simple/uploader',
		exact: false,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: UploaderIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.simple.accordion',
		path: '/poc/simple/accordion',
		exact: false,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: AccordionIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.edit.customer',
		path: '/poc/edit/customer',
		exact: true,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: EditCustomerIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.edit.product',
		path: '/poc/edit/product',
		exact: true,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: EditProductIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.icon.list',
		path: '/poc/icon/list',
		exact: true,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: IconListIndex,
		routeScopes: ['*'],
	},
	{
		name: 'poc.datatable',
		path: '/poc/datatable',
		exact: false,
		isPublic: false,
		layout: {
			header: true,
			footer: false,
			sidebar: true,
		},
		component: DatatableIndex,
		routeScopes: ['*'],
	},
];
